import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { FeatureGuide } from './FeatureGuide'
import '@/features/wealth/wealth.css'
import { useAppStore } from '@/store'
import { cn } from '@/lib/utils'

export function MainLayout() {
  const sidebarOpen = useAppStore((state) => state.sidebarOpen)

  return (
    <div className="min-h-screen bg-background">
      <a className="wealth-skip" href="#main-content">К содержимому</a>
      <Sidebar />
      <div
        className={cn(
          'flex flex-col transition-all duration-300',
          sidebarOpen ? 'lg:pl-64' : 'lg:pl-20'
        )}
      >
        <Header />
        <main id="main-content" className="flex-1 min-w-0 p-4 lg:p-6">
          <FeatureGuide />
          <Outlet />
        </main>
      </div>
    </div>
  )
}
